const home = [
  {
    component: () => import('@/app/web/pages/Home/Home.vue'),
    name: 'Home',
    path: '/',
    meta: {
      title: 'Accueil'
    }
  },
];

/** ------------- */
// TODO : A supprimer
const popups = [
  {
    component: () => import('@/app/web/pages/Popup/Video.vue'),
    name: 'Video',
    path: '/video/:sit_id(\\d+)/:dev_id(\\d+)/:dvv_id(\\d+)/',
  },
  {
    component: () => import('@/app/web/pages/Popup/Video_Externe.vue'),
    name: 'Video_Externe',
    path: '/video_externe/:dev_id(\\d+)_:dvv_id(\\d+)/',
  },
];

/** ---- COMPANY ----- */
const company = [
  {
    component: () => import('@/app/web/pages/Company/Company.vue'),
    name: 'Company',
    path: '/entreprise/',
    meta: {
      fullscreen: true,
      title: 'Entreprise',
      rights: {
        levels: [4, 5],
        name: "ENTREPRISE.page_entreprise"
      }
    }
  },
  /*
  {
    component: () => import('@/app/web/pages/Company/Company_Edit.vue'),
    name: 'Company_Edit',
    path: '/entreprise/modifier/',
    meta: {
      fullscreen: true,
      title : 'Modifier l\'entreprise'
    }
  },
  */
]

/** ---- USERS ----- */
const users = [
  {
    component: () => import('@/app/web/pages/Compte/Mon_compte.vue'),
    name: 'Mon_compte',
    path: '/mon_compte/',
    meta: {
      title: 'Mon compte'
    }
  },
  {
    component: () => import('@/app/web/pages/Compte/Compte_Edit.vue'),
    name: 'Compte_Edit',
    path: '/entreprise/compte/:con_id(\\d+)',
    meta: {
      rights: {
        levels: [5],
        name: "ENTREPRISE.USER.edit_other_account"
      },
      title: 'Modifier le compte',
      fullscreen: true
    }
  },
  {
    component: () => import('@/app/web/pages/Compte/Compte_Create.vue'),
    name: 'Compte_Create',
    path: '/entreprise/compte/ajouter/',
    meta: {
      rights: {
        levels: [5],
        name: "ENTREPRISE.USER.create"
      },
      title: 'Ajouter un compte'
    }
  },
  {
    component: () => import('@/app/web/pages/Compte/Compte_Import.vue'),
    name: 'Compte_Import',
    path: '/entreprise/compte/import/',
    meta: {
      rights: {
        levels: [5],
        name: "ENTREPRISE.USER.import_csv"
      },
      title: 'Importer des comptes'
    }
  },
  {
    component: () => import('@/app/web/pages/Compte/Compte_UserRight.vue'),
    name: 'Compte_UserRight',
    path: '/entreprise/compte/roles/',
    meta: {
      rights: {
        levels: [5],
        name: "ENTREPRISE.USER.edit_user_right"
      },
      title: 'Droits des utilisateurs',
      fullscreen: true
    }
  },
  {
    component: () => import('@/app/web/pages/Compte/Settings.vue'),
    name: 'My_Settings',
    path: '/mon_compte/settings/',
    meta: {
      title: 'Mes paramètres',
      rights: {
        levels: [5],
        name: "USER.mon_compte"
      },
    }
  }
];

/** ---- DEVICES ----- */
const devices = [
  {
    component: () => import('@/app/web/pages/Device/Devices.vue'),
    name: 'Devices',
    path: '/appareils/',
    meta: {
      fullscreen: true,
      title: 'Appareils',
      rights: {
        levels: [2, 3, 4, 5],
        name: "DEVICES.page_devices"
      }
    }
  },
  {
    component: () => import('@/app/web/pages/Device/Device_Create.vue'),
    name: 'Device_Create',
    path: '/appareils/ajouter/',
    meta: {
      rights: {
        levels: [3, 4, 5],
        name: "DEVICES.create"
      },
      title: 'Ajouter un appareil'
    }
  },
];


/** ---- MISSSION ----- */
// const mission = [
//   {
//     component: () => import('@/app/web/pages/_Missions/Missions.vue'),
//     name: 'Mission',
//     path: '/mission/:mis_id(\\d+)',
//     meta: {
//       title: 'Mission',
//       rights: {
//         levels: [3, 4, 5],
//         name: "MISSION.page_mission"
//       },
//     }
//   },
// ];
/** ---- MISSSION END ----- */

/** ---- CARTE ---- */
const cartes = [
  {
    component: () => import('@/app/web/pages/Map/Carte.vue'),
    name: 'Cartes',
    path: '/site/:sit_id(\\d+)/cartes/',
    meta: {
      title: 'Cartes',
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.page_carte"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Map/Tracker/Trackers.vue'),
    name: 'Trackers',
    path: '/site/:sit_id(\\d+)/cartes/trackers/',
    meta: {
      title: 'Trackers',
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.TRACKERS.page_tracker"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Map/Tracker/Tracker_Edit.vue'),
    name: 'Tracker_Edit',
    path: '/site/:sit_id(\\d+)/cartes/tracker/:trk_id(\\d+)',
    meta: {
      title: 'Modifier le tracker',
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.TRACKERS.edit"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Map/MapElements/MapElements.vue'),
    name: 'MapElements',
    path: '/site/:sit_id(\\d+)/cartes/elements/',
    meta: {
      title: 'Map-Elements',
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.MAPELEMENTS.page_mapelements"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Map/MapElements/Import_FTS_MAPELEMENTS.vue'),
    name: 'Import_FTS_MAPELEMENTS',
    path: '/site/:sit_id(\\d+)/cartes/elements/import_fts/',
    meta: {
      title: 'Importer des éléments',
      rights: {
        levels: [4, 5],
        name: "CARTE.MAPELEMENTS.import_fts"
      },
    }
  }
];

/** ---- CARTE END ----- */

/** ---- SITE ---- */
const site = [
  {
    component: () => import('@/app/web/pages/Site/Site.vue'),
    name: 'Site',
    path: '/site/:sit_id(\\d+)',
    meta: {
      title: 'Site'
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Site_Edit.vue'),
    name: 'Site_Edit',
    path: '/site/:sit_id(\\d+)/option/',
    meta: {
      rights: {
        levels: [4, 5],
        name: "SITES.EDIT.edit"
      },
      title: 'Modifier le site'
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Site_Create.vue'),
    name: 'Site_Create',
    path: '/site/ajouter/',
    meta: {
      rights: {
        levels: [4, 5],
        name: "SITES.EDIT.create"
      },
      title: 'Ajouter un site'
    }
  },
];

const site_flight = [
  {
    component: () => import('@/app/web/pages/Site/Flight/Site_Flights.vue'),
    name: 'Site_Flights',
    path: '/site/:sit_id(\\d+)/planificateur/:dev_id(\\d+)?/',
    meta: {
      fullscreen: false,
      title: 'Planificateur',
      rights: {
        levels: [4, 5],
        name: "FLIGHTS.page_vol"
      },
    }
  },
];

const history = [
  {
    component: () => import('@/app/web/pages/History/Historys.vue'),
    name: 'Historys',
    path: '/historique/',
    meta: {
      fullscreen: true,
      title: 'Historiques',
      rights: {
        levels: [4, 5],
        name: "HISTORIQUE.page_historique"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/History/History.vue'),
    name: 'History',
    path: '/historique/:flr_id',
    meta: {
      title: 'Historique',
      rights: {
        levels: [4, 5],
        name: "HISTORIQUE.page_historique"
      },
    }
  }
];

const site_mediatheque = [
  {
    component: () => import('@/app/web/pages/Site/Mediatheque/Site_Mediatheque.vue'),
    name: 'Site_Mediatheque',
    path: '/site/:sit_id(\\d+)/media/',
    meta: {
      fullscreen: true,
      title: 'Médiathèque',
      rights: {
        levels: [2, 3, 4, 5],
        name: "MEDIATHEQUE.page_mediatheque"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Mediatheque/Site_Files.vue'),
    name: 'Site_Files_flr_id',
    path: '/site/:sit_id(\\d+)/media/:flr_id',
    meta: {
      fullscreen: true,
      title: 'Fichiers',
      rights: {
        levels: [2, 3, 4, 5],
        name: "MEDIATHEQUE.page_fichier"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Mediatheque/Site_Files.vue'),
    name: 'Site_Files_virtualdir',
    path: '/site/:sit_id(\\d+)/media/:dev_id-:virtualdir',
    meta: {
      fullscreen: true,
      title: 'Fichiers',
      rights: {
        levels: [2, 3, 4, 5],
        name: "MEDIATHEQUE.page_fichier"
      },
    }
  },
];

const site_zone2vol = [
  {
    component: () => import('@/app/web/pages/Site/Zone2Vol/Site_Zone2Vol.vue'),
    name: 'Site_Zone2Vol',
    path: '/site/:sit_id(\\d+)/zone/',
    meta: {
      rights: {
        levels: [4, 5],
        name: "ZONE2VOL.page_zone2vols"
      },
      title: 'Zone de vol'
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Zone2Vol/Site_Zone2VolCreate.vue'),
    name: 'Site_Zone2VolCreate',
    path: '/site/:sit_id(\\d+)/zone/ajouter/',
    meta: {
      rights: {
        levels: [4, 5],
        name: "ZONE2VOL.create"
      },
      title: 'Ajouter une zone de vol'
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Zone2Vol/Site_Zone2VolEdit.vue'),
    name: 'Site_Zone2VolEdit',
    path: '/site/:sit_id(\\d+)/zone/modifier/:cua_id(\\d+)',
    meta: {
      rights: {
        levels: [4, 5],
        name: "ZONE2VOL.edit"
      },
      title: 'Modifier la zone de vol'
    }
  },
];

const site_device = [
  {
    component: () => import('@/app/web/pages/Site/Device/Site_Devices.vue'),
    name: 'Site_Devices',
    path: '/site/:sit_id(\\d+)/appareils/',
    meta: {
      fullscreen: true,
      title: 'Appareils',
      rights: {
        levels: [3,4, 5],
        name: "DEVICES.page_devices"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Device/Site_DeviceEdit.vue'),
    name: 'Site_DeviceEdit',
    path: '/site/:sit_id(\\d+)/appareil/modifier/:dev_id(\\d+)',
    meta: {
      rights: {
        levels: [3,  4, 5],
        name: "DEVICES.edit"
      },
      fullscreen: true,
      title: 'Modifier l\'appareil'
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Device/Site_DeviceCreate.vue'),
    name: 'Site_DeviceCreate',
    path: '/site/:sit_id(\\d+)/appareil/ajouter/',
    meta: {
      rights: {
        levels: [3, 4, 5],
        name: "DEVICES.create"
      },
      title: 'Ajouter un appareil'
    }
  },
];

/** ---- SITE END ----- */

/** ---- SITE MODELE 3D ----- */
const site_model3d = [
  {
    component: () => import('@/app/web/pages/Site/Model3d/Site_Model3D.vue'),
    name: 'Site_Model3D',
    path: '/site/:sit_id(\\d+)/model/',
    meta: {
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.MODEL3D.page_model3d"
      },
      title: 'Modèle 3D'
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Model3d/Site_Model3D_Add.vue'),
    name: 'Site_Model3D_Add',
    path: '/site/:sit_id(\\d+)/model/ajouter/',
    meta: {
      title: 'Ajouter un modèle 3D',
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.MODEL3D.create"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Site/Model3d/Site_Model3D_Edit.vue'),
    name: 'Site_Model3D_Edit',
    path: '/site/:sit_id(\\d+)/model/editer/:model_id(\\d+)',
    meta: {
      title: 'Modifier le modèle 3D',
      rights: {
        levels: [3, 4, 5],
        name: "CARTE.MODEL3D.edit"
      },
    }
  },
];
/** ----  SITE MODELE 3D END ----- */

/** ---- CUSTOM MAP ----- */
const custommap = [
  {
    component: () => import('@/app/web/pages/CustomMaps/CustomMap_Add.vue'),
    name: 'CustomMap_Add',
    path: '/custommap/ajouter/',
    meta: {
      title: 'Ajouter une carte personnalisée'
    }
  },
  {
    component: () => import('@/app/web/pages/CustomMaps/CustomMap_Edit.vue'),
    name: 'CustomMap_Edit',
    path: '/custommap/editer/:map_key(\\d+)/',
    meta: {
      title: 'Modifier la carte personnalisée'
    }
  }
];
/** ---- END CUSTOM MAP ----- */


/** ---- Mission ----- */
const mission = [
  {
    component: () => import('@/app/web/pages/Missions/Missions.vue'),
    name: 'Missions',
    path: '/site/:sit_id(\\d+)/missions/',
    meta: {
      title: 'Missions',
      rights: {
        levels: [3, 4, 5],
        name: "MISSION.page_mission"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Missions/Mission_Add.vue'),
    name: 'Mission_Add',
    path: '/site/:sit_id(\\d+)/missions/ajouter/',
    meta: {
      title: 'Ajouter une mission',
      rights: {
        levels: [3, 4, 5],
        name: "MISSION.create"
      },
    }
  },
  {
    component: () => import('@/app/web/pages/Missions/Mission_Edit.vue'),
    name: 'Mission_Edit',
    path: '/site/:sit_id(\\d+)/missions/editer/:flight_id(\\d+)/',
    meta: {
      title: 'Modifier la mission',
      rights: {
        levels: [3, 4, 5],
        name: "MISSION.edit"
      },
    }
  },
];
/** ---- END Flights ----- */

const router = [
  ...home,
  ...popups,
  ...company,
  ...users,
  ...devices,
  ...mission,
  ...cartes,
  ...site,
  ...site_flight,
  ...site_mediatheque,
  ...history,
  ...site_zone2vol,
  ...site_device,
  ...site_model3d,
  ...custommap,
];

export default router;
